import { useState, useRef, useEffect, useCallback } from "react";
import EnterOverlay from "@/components/EnterOverlay";
import Experience from "@/components/Experience";
import YouTubeBackground from "@/components/YouTubeBackground";
import AudioPlayer from "@/components/AudioPlayer";
import BoxMascot from "@/components/BoxMascot";
import CheckoutReturn from "@/components/CheckoutReturn";
import { BG_TRACK } from "@/data/worldData";

export default function Home() {
  const [sessionId, setSessionId] = useState(() => new URLSearchParams(window.location.search).get("session_id"));
  const [entered, setEntered] = useState(() => new URLSearchParams(window.location.search).get("enter") === "1");
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(false);
  const [volume, setVolume] = useState(0.6);
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current) audioRef.current.volume = muted ? 0 : volume;
  }, [volume, muted]);

  const handleEnter = useCallback(() => {
    setEntered(true);
    const a = audioRef.current;
    if (a) {
      a.volume = volume;
      a.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
  }, [volume]);

  const togglePlay = useCallback(() => {
    const a = audioRef.current;
    if (!a) return;
    if (a.paused) a.play().then(() => setPlaying(true)).catch(() => {});
    else { a.pause(); setPlaying(false); }
  }, []);

  const closeCheckout = useCallback(() => {
    window.history.replaceState({}, "", window.location.pathname);
    setSessionId(null);
  }, []);

  return (
    <div className="App">
      <audio ref={audioRef} src={BG_TRACK} loop preload="auto" />
      {sessionId && <CheckoutReturn sessionId={sessionId} onDone={closeCheckout} />}
      {!entered && <EnterOverlay onEnter={handleEnter} />}
      {entered && (
        <>
          <YouTubeBackground />
          <Experience />
          <AudioPlayer
            playing={playing}
            onToggle={togglePlay}
            muted={muted}
            onMute={() => setMuted((m) => !m)}
            volume={volume}
            onVolume={(v) => { setVolume(v); if (v > 0) setMuted(false); }}
          />
          <BoxMascot />
        </>
      )}
    </div>
  );
}
